import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiErrorMessage, getToken, setToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [status, setStatus] = useState("checking"); // checking | authed | anon
  const [error, setError] = useState("");

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setStatus("anon");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setStatus("authed"))
      .catch(() => {
        setToken(null);
        setStatus("anon");
      });
  }, []);

  const login = useCallback(async (password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { password: (password || "").trim() });
      setToken(data.access_token);
      setStatus("authed");
      return true;
    } catch (e) {
      setError(apiErrorMessage(e, "No se pudo iniciar sesión"));
      return false;
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {
      /* ignore */
    }
    setToken(null);
    setStatus("anon");
  }, []);

  return (
    <AuthContext.Provider value={{ status, error, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
